// extracted by mini-css-extract-plugin
export default {"wrapper":"Dropdown_wrapper","label":"Dropdown_label","active":"Dropdown_active","popup":"Dropdown_popup","item":"Dropdown_item"};